import apiClient from '../apiClient';
import { POST_CITY_GROUP_DETAIL_FULLADD_URL } from '../apiUrl';

const postCitiGroupDetailFullAddApi = (id, data) => {
  return apiClient.post(POST_CITY_GROUP_DETAIL_FULLADD_URL(id), data);
};

export default postCitiGroupDetailFullAddApi;
